import * as ko from "knockout"
import { ElementLocationViewModel } from "../ElementLocationViewModel"
import { StylesViewModel } from "./StylesViewModel"
import { AccountViewModel } from "../AccountViewModel";

export class FieldElementViewModel  extends ElementLocationViewModel {
    field: KnockoutObservable<string>;
    text: KnockoutObservable<string>;
    isLoading: KnockoutObservable<boolean>;
    fieldCodes: KnockoutObservableArray<string>;
    styles: KnockoutObservable<StylesViewModel>;

    constructor(elementType: string, private accountViewModel: AccountViewModel) {
        super(elementType);
        var self = this;

        this.isLoading = ko.observable(false);
        this.fieldCodes = ko.observableArray([]);

        this.field = ko.observable("");
        this.text = ko.computed(() => {
            if (self.field() == "") {
                return "";
            }   
            else {
                return "((" + self.field() + "))"
            }
        });

        this.columnSpan(20);
        this.rowSpan(1);
        this.styles = ko.observable(new StylesViewModel());
    }

    public clone(): ElementLocationViewModel {
        let ret = new FieldElementViewModel(this.elementType, this.accountViewModel);
        super.cloneThis(ret);

        ret.field(this.field());
        ret.styles(this.styles().clone());

        return ret;
    }

    public getData(data): any {
        super.getData(data);
        data.field = this.field;
        data.text = this.text;
        data.styles = this.styles;
    }
}


// WEBPACK FOOTER //
// ./code/elements/FieldElementViewModel.ts